export default __webpack_public_path__ + "static/media/RW-ArabiaSaudita(1140x600).d0727a91.webp";